import { doFetch } from '@app/services/http-client';
import { writable } from 'svelte/store';
export const unreadMessages = writable(0);
export function updateUnreadMessagesCount() {
    doFetch("https://iapi.glosbe.com/iapi3/authenticate", {
        credentials: "include",
    }).then(result => {
        if (result && result.unreadMessages) {
            unreadMessages.set(result.unreadMessages);
        }
    });
}
